export default __webpack_public_path__ + "static/media/decorative-image-4.dc14f27e.jpg";